import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findDepartment = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department?`+params,
        method: 'GET'
    })
}

export const findDepartmentAll = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/choose`,
        method: 'GET'
    })
}
// 获取部门树形结构
export const findDepartmentTree = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/departmentTree`,
        method: 'GET'
    })
}
export const findDepartmentDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/${id}`,
        method: 'GET'
    })
}

export const addDepartment = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department`,
        method: 'POST',
        data: data
    })
}
export const addDepartmentAgent = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/agent`,
        method: 'POST',
        data: data
    })
}

export const editDepartment = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department`,
        method: 'PUT',
        data: data
    })
}

export const delDepartment = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}